import { ArrowDownIcon, ShieldCheckIcon, WalletIcon } from "@phosphor-icons/react";
import { useState } from "react";

import { DashboardContent } from "../../components/layout/dashboard-content";
import { WalletBalanceCard } from "./components/wallet-balance-card";
import { WithdrawalForm } from "./components/withdrawal-form";
import { WithdrawalsHistory } from "./components/withdrawals-history";
import { useWalletDashboard } from "./hooks/use-wallet-dashboard";

export const WalletPage = () => {
  const [page, setPage] = useState(1);

  const { wallet, withdrawals, loading, refreshing, refetch, withdraw, isWithdrawing } =
    useWalletDashboard(page);

  return (
    <DashboardContent>
      <section className="mx-auto min-w-0 max-w-6xl space-y-6 pb-10">
        <header className="relative overflow-hidden rounded-3xl bg-[#071451] px-5 py-6 text-white shadow-[0_18px_45px_rgba(7,20,81,0.18)] sm:px-8 sm:py-8">
          <div className="absolute -right-16 -top-20 size-56 rounded-full bg-indigo-500/25 blur-3xl" />
          <div className="absolute -bottom-24 right-24 size-48 rounded-full bg-emerald-400/20 blur-3xl" />

          <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-emerald-300">
                Espace affiliation
              </p>

              <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-3xl">
                Portefeuille & Retraits
              </h1>

              <p className="mt-2 max-w-xl text-sm leading-6 text-indigo-100/80">
                Gérez vos gains et transférez-les en toute sécurité vers Mobile Money ou votre
                compte bancaire.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-2 sm:w-auto">
              <span className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/10 px-3 py-2 text-[10px] font-semibold">
                <WalletIcon size={16} />
                Solde actualisé
              </span>

              <span className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/10 px-3 py-2 text-[10px] font-semibold">
                <ShieldCheckIcon size={16} />
                Retrait sécurisé
              </span>
            </div>
          </div>
        </header>

        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_400px]">
          <div className="space-y-6">
            <WalletBalanceCard
              wallet={wallet}
              loading={loading}
              refreshing={refreshing}
              onRefresh={refetch}
            />

            <WithdrawalsHistory
              data={withdrawals}
              loading={loading}
              page={page}
              onPageChange={setPage}
            />
          </div>

          <div id="withdrawal-form" className="scroll-mt-6 lg:sticky lg:top-6 lg:self-start">
            <WithdrawalForm
              balance={wallet?.balance ?? 0}
              isWithdrawing={isWithdrawing}
              onSubmit={withdraw}
            />
          </div>
        </div>

        <button
          type="button"
          onClick={() =>
            document.getElementById("withdrawal-form")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            })
          }
          className="fixed bottom-20 right-4 z-20 inline-flex size-12 items-center justify-center rounded-full bg-gradient-to-br from-indigo-700 to-emerald-500 text-white shadow-xl lg:hidden"
          aria-label="Aller au formulaire de retrait"
        >
          <ArrowDownIcon size={20} weight="bold" />
        </button>
      </section>
    </DashboardContent>
  );
};
